import React, { Component } from 'react';

import {Table, TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import Config from '../../conf';
import Util from '../../Util';

import moment from 'moment';

import {ConfirmAndPay as styles} from './form.css';

import 'whatwg-fetch';

class ConfirmAndPay extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      bookButtonDisabled: false,
      error: false,

      bookingCompleted: false
    };

    this.onToken = this.onToken.bind(this);
    this.sendToBackend = this.sendToBackend.bind(this);
    this.bookButtonClicked = this.bookButtonClicked.bind(this);
    this.retry = this.retry.bind(this);
  }

  bookButtonClicked() {
    this.setState({
      bookButtonDisabled: true
    }, () => {
      this.onToken()
      setTimeout(() => {
        this.setState({
          bookButtonDisabled: false
        });
      }, 5000);
    });
  }

  retry() {
    this.setState({
      bookButtonDisabled: false,
      loading: false,
      error: false
    });
    this.onToken(this.state.stripeToken);
  }

  getBookingTime() {
    const date = this.props.details.date;
    const time = this.props.details.time;

    return Util.monthToString(date.getMonth()) + ' ' + date.getDate() + ', ' + date.getFullYear() + ' - ' + time;
  }

  sendToBackend(body) {
    // set to loading mode
    this.setState({
      loading: true
    });
    
    return new Promise((resolve, reject) => {
      fetch(Config.BACKEND_API_URL + 'booking/guest', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then((response) => {
        return response.json().then(data => {
          if (data.status === 200 || data.result === 'success') {
            resolve();
          } else {
            throw data;
          }
        });
      }).catch(err => {
        this.props.updateField('stripeError', true);
        this.props.updateField('stripeMessage', err["stripeMessage"]);
        this.props.back();
        reject(err);
      });
    });
  }

  onToken() {
    const token = this.props.details.stripeToken;
    // set paid flag
    this.setState({
      stripePaid: true,
      stripeToken: token
    });

    const description = 'B2C ' + this.props.details.carType + ' ' + this.props.details.washType + '\n' +
                        'WhiteLabel ' + Config.CLIENT_NAME + ' Booking';

    const date = moment(this.props.details.date);

    const startTime = this.props.details.startTime;
    const endTime = this.props.details.endTime;

    const body = {
      tokenId: token ? token.id : null,
      description: description,
      name: this.props.details.name,
      email: this.props.details.email,
      phone: this.props.details.phone,
      address: this.props.details.address,
      numberPlate: this.props.details.numberPlate,
      carType: this.props.details.carType,
      washType: this.props.details.washType,
      extras: [], 
      notes: 'Carpark Level: ' +  this.props.details.carParkLevel + ' -- Carpark Spot: ' + this.props.details.carParkSpot,

      date: {
        d: date.date(),
        m: date.month(),
        y: date.year()
      },

      startTime: {
        h: startTime.hours,
        m: startTime.mins
      },

      endTime: {
        h: endTime.hours,
        m: endTime.mins
      },

      whiteLabel: Config.CLIENT_NAME,
      member: this.props.details.fpMember,
      company: this.props.details.company || '',
      platform: Config.CLIENT_NAME
    };

    this.sendToBackend(body).then(() => {
      this.setState({
        bookingCompleted: true
      });
    }).catch(err => {
      this.setState({
        error: true
      });
      console.log('Failed to send to backend: ' + err);
    });
  };

  render() {
    const rows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Email Address', value: this.props.details.email },
      { name: 'Mobile Number', value: this.props.details.phone },
      { name: 'Car Address', value: this.props.details.address },
      { name: 'Number Plate', value: this.props.details.numberPlate },
      { name: 'Booking Time', value: this.getBookingTime() },
      { name: 'Wash Type', value: this.props.details.carType + ' ' + 
          this.props.details.washTypeDisplay + ' $' +
          this.props.details.washPrice.toFixed(2) 
        }
    ];

    return (
      <div>
      {!this.state.error && !this.state.loading && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>
            {this.props.details.fpMember ? 'Confirm Booking' : 'Confirm And Pay'}
          </h2>

            {this.props.details.isSmallScreen ?
              <div>
              {rows.map((row) => {
                return (
                  <p key={row.name}>
                    <strong>{row.name}</strong>:
                    <br />
                    {row.value}
                  </p>
                );
              })}
              </div>
            :
              <Table selectable={false} style={styles.table}>
                <TableBody displayRowCheckbox={false}>
                {rows.map((row) => {
                  return (
                    <TableRow key={row.name}>
                      <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                      <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                    </TableRow>
                  );
                })}
                </TableBody>
              </Table>
            }

            <RaisedButton style={styles.button}
              label="Back" primary={true} onClick={this.props.back} />
            {this.props.details.fpMember &&
              <RaisedButton
                style={styles.button}
                label="Confirm"
                primary={true}
                onClick={this.onToken}
              />
            }
            
            {!this.state.stripePaid &&
              <RaisedButton
                style={styles.button}
                label="Book"
                primary={true}
                disabled={this.state.bookButtonDisabled}
                onClick={this.bookButtonClicked}
              />
            }
        </Card>
      }
      {this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Finished</h2>
          <CardText>
            Thank you, your car wash has been booked. You will also receive SMS and email notifications shortly.
          </CardText>
        </Card>
      }
      {!this.state.error && this.state.loading && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Making your booking...</h2>
          <CardText>
            <CircularProgress />
          </CardText>
        </Card>
      }
      {this.state.error && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Error</h2>
          <CardText>
            <div>
              An error occurred.
            </div>
            <div>
              <RaisedButton
                style={{...styles.button,...{marginTop: 40}}}
                label="Retry"
                primary={true}
                onClick={this.retry}
              />
            </div>
          </CardText>
        </Card>
      }
      </div>
    );
  }
}

export default ConfirmAndPay;



// WEBPACK FOOTER //
// ./src/app/components/form/ConfirmAndPay.js